const primaryMain = '#502D7F';
const primaryMainOpacity = 'rgba(80, 45, 127, 0.9)';
const secondaryMain = '#F4DA40';
const secondaryMainOpacity = 'rgba(244, 218, 64, 0.5)';
const secondaryLight = '#236192';
const tertiaryMain = '#000000';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
